
<template>
  <div style="padding:25px 10px; text-align:center">
    <img src="@/assets/images/noData.png">
    <slot>
      <p style="color:#c4c4c4">暂无数据</p>
    </slot>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
</style>

